import React, { useEffect, useState } from 'react'
import './approved-declined-modal.styles.scss'

import Modal from '@/components/modal/modal.component'
import { useLocation, useNavigate } from 'react-router-dom'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { UseCloudGameTransactions } from '@/utils/firebase.utils'
import { useSelector } from 'react-redux'
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component'

const ApprovedDeclinedModal = ({
  gameData,
  playerData,
  gameElements }) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [element, setElement] = useState(null);
  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!playerData || !gameElements) return;
    if (playerData.newStuff && playerData.newStuff.length > 0) {
      for (let act of playerData.newStuff) {
        if (
          act.type === 'declinedChallenge' ||
          act.type === 'declinedItem' ||
          (
            act.type === 'approvedItem' &&
            (
              !act.data ||
              act.data.length === 0
            )
          ) ||
          (
            act.type === 'approvedChallenge' &&
            (
              !act.data ||
              act.data.length === 0
            )
          )
        ) {
          let elementData;
          if (!act.elementId || !gameElements[act.elementId]) {
            elementData = {
              "icon": "https://cdn.gamably.com/defaults/misc/unknown_icon.png",
              "name": "Unknown Element",
              "type": act.type === 'declinedChallenge' ? 'challenge' : 'item',
              "desc": "This element is missing or has been deleted."
            }
          } else {
            elementData = gameElements[act.elementId];
          }
          setElement(elementData);
          setActivity(act);
          break;
        }
      }
    }
  }, [playerData, gameElements])

  async function goToElement() {
    setLoading(true);
    const data = {
      'gameId': gameData.gameId,
      'playerId': playerData.playerId,
      'rewardIdArr': [activity.id]
    }
    // if (!location.pathname.includes('/preview/player/')) {
    //   const res = await UseCloudGameTransactions('markRewardAsViewed', data);
    //   console.log(res);
    // }
    console.log(element);
    if (element.type === 'challenge') {
      navigate(`/play/${gameData.path}/challenges/${element.path}`);
      setElement(null);
    } else if (element.type === 'item') {
      setElement(null);
    }
    setLoading(false);
  }

  return (
    <div>
      <Modal
        show={element && activity}
        cancel={() => setElement(null)}
        cls={
          screenSize === 'mobile'
            ? 'full'
            : screenSize === 'tablet' ?
              '' :
              'narrow'
        }
        text={`${activity?.type.includes('approved')
            ? 'Approved'
            : 'Declined'
          } ${activity?.type.includes('Challenge')
            ? 'Challenge'
            : 'Item'
          }
                `}>
        <div className='modal-children'>
          {
            (element && activity) &&
            <div className='approved-declined-modal'>
              <ImageContainer
                src={element.icon}
                alt={`${element.name} icon`}
                className='treasure-gif' />
              <p>{element.name}</p>
              <h3>
                {
                  (activity.type === 'approvedChallenge')
                    ? 'You have an approved challenge! Click the button below to check it out.'
                    : (activity.type === 'declinedChallenge')
                      ? 'You have a declined challenge. Click the button below to check it out.'
                      : (activity.type === 'approvedItem')
                        ? 'You have an approved item! You can find information in your inventory history.'
                        : (activity.type === 'declinedItem')
                          ? 'You have a declined item. You can find information in your inventory history.'
                          : ''
                }
              </h3>

              <hr />
              <div className="buttons">
                {
                  (loading)
                    ?
                    <button className="g-button"><ThreeDotsLoader /></button>
                    :
                    <button className="g-button" onClick={() => goToElement()}>
                      {
                        element.type === 'challenge' ?
                          'Go to Challenge' :
                          element.type === 'item' ?
                            'Ok' :
                            ''
                      }
                    </button>
                }
              </div>
            </div>
          }
        </div>
      </Modal>
    </div>
  )
}

export default ApprovedDeclinedModal